import type { DefaultError, UseMutationResult } from '@tanstack/react-query';
import React, { createContext, use } from 'react';

interface MutationContextType<
  TData = unknown,
  TError = DefaultError,
  TVariables = unknown,
  TContext = unknown
> {
  mutation: UseMutationResult<TData, TError, TVariables, TContext>;
}

const MutationContext = createContext<
  /* oxlint-disable-next-line typescript/no-explicit-any */
  MutationContextType<any, any, any, any> | undefined
>(undefined);

export function MutationProvider<
  TData = unknown,
  TError = DefaultError,
  TVariables = unknown,
  TContext = unknown
>({
  children,
  mutation
}: React.PropsWithChildren<{
  mutation: UseMutationResult<TData, TError, TVariables, TContext>;
}>) {
  return <MutationContext value={{ mutation }}>{children}</MutationContext>;
}

export function useMutationContext<
  TData = unknown,
  TError = DefaultError,
  TVariables = unknown,
  TContext = unknown
>() {
  const context = use<MutationContextType<TData, TError, TVariables, TContext> | undefined>(
    MutationContext
  );

  return context?.mutation;
}
